<template>
  <el-container style="height:100%">
    <el-aside class="transition-width-change" :width="collapse ? collapseWidth : winWidth">
      <el-scrollbar style="height:100%" wrap-class="scrollbar-wrapper">
        <l-aside :collapse="collapse" />
      </el-scrollbar>
    </el-aside>
    <el-container>
      <el-header id="back_top_header">
        <t-header v-model="collapse" />
      </el-header>
      <el-main style="height:100%">
        <section class="app-main">
          <el-scrollbar
            class="selfscrollbar"
            style="height:100%;overflow-y:auto"
            id="backtop-target"
            wrap-class="scrollbar-wrapper baktop"
          >
            <transition name="el-fade-in-linear" mode="out-in">
              <router-view :key="key()" />
            </transition>
          </el-scrollbar>
          <el-backtop target=".baktop" :bottom="100">
            <div
              style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
            >
              <i class="el-icon-arrow-up"></i>
            </div>
          </el-backtop>
          <!-- <bottom-bar /> -->
        </section>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LAside from "./lAside";
import THeader from "./tHeader";
import BottomBar from "../../components/bottom-bar/index";
import toggle from "../../plugins/ws";
export default {
  components: { LAside, THeader, BottomBar },
  mixins: [toggle],
  data: () => ({
    collapse: false,
    winWidth: "260px",
    collapseWidth: "64px"
  }),
  methods: {
    key() {
      return this.$route.path;
    }
  }
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
}
.app-main {
  /* 50= navbar  50  */
  /* min-height: calc(100vh - 60px - 10px - 40px); */
  height: calc(100vh - 60px - 40px);
  width: 100%;
  position: relative;
}

.el-header,
.el-footer {
  background-color: #ffffff;
  line-height: 60px;
}

.el-aside {
  background-color: #ffffff;
  height: 100vh;
}

.el-main {
  background-color: #f2f2f2;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.scrollbar-wrapper {
  overflow-x: hidden !important;
}

.transition-width-change {
  transition: 0.5s;
}
</style>